import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { BrandManipulationView } from "./brandManipulation-view"
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";

export class BrandManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت برندها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.brands = ObservableArray.create<brand>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new BrandManipulationView();
    }
    public getTypeId(): string {
        return "VM-FBF4904D-069F-44F8-B622-382AF685A5D4"
    }
    public set brands(v: ObservableArray<brand>) { this._brands = v; } public get brands(): ObservableArray<brand> { return this._brands;} private _brands: ObservableArray<brand>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllBrand',{
                FilteringInformation:filteringInformation
            });
            this.brands.update(...result.Brand.map(q=>{
                let r = new brand(this);
                r.id = q.Id;
                r.name = q.Name;
                r.code = q.Code;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestBrandCreation(){
        let editor = new brandEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async brandUpdater(brand:brand){
        let editor = new brandEditor(this,new UpdateServerUpdater());
        brand.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
}

export class brand extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:BrandManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    private _typedParent:BrandManipulationViewModel;

    clone(parent:BrandManipulationViewModel):brand{
        let u = new brand(parent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(brand:brand){
        brand.id = this.id;
        brand.name = this.name;
        brand.code = this.code;
    }

    async edit(){
        this._typedParent.brandUpdater(this);
    }    
}

interface IServerUpdater{
    execute(brand:brand):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'برند با موفقیت ثبت شد.';
    }
    async execute(brand: brand): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateBrand',{
            Name:brand.name,
            Code:brand.code
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'برند با موفقیت به روز رسانی شد.';

    }
    async execute(brand: brand): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdateBrand',{
            Id:brand.id,
            Name:brand.name,
            Code:brand.code
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class brandEditor extends brand implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:BrandManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام برند مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.code)){
            result.push('کد برند مشخص نشده است.')
        }
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت برند');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class BrandSelectorViewModel extends SelectorBaseViewModel<brandForSelector>{
    protected async loadData(): Promise<brandForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllBrand',{});
        return result.Brand.map(q=>{
            let result = new brandForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

class brandForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}
